import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/9ygc03ws_100%25%20GUNA%20SMART%20DESK.jpg",
      alt: "100% Guna Smart Desk"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/a5obunez_FLIP%20LEBIH%20100%25.jpg",
      alt: "Flip Lebih 100%"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/b3xwa797_HASIL%202%20MINGGU%20FOLLOW%20FIRA.jpg",
      alt: "Hasil 2 Minggu Follow Fira"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/hb1vxs4r_STUDENT%20FOLLOW%20RAPAT%20SETUP%20H4.jpg",
      alt: "Student Follow Rapat Setup H4"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/lxyvgspl_STUDENT%20TRADE%20GUNA%20FSD.jpg",
      alt: "Student Trade Guna FSD"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/6t5t7sva_TRADE%20CONFIDENCE.jpg",
      alt: "Trade Confidence"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/3i2dmfnt_STUDENT%20100%25%20FOLLOW%20SMART%20DESK.jpg",
      alt: "Student 100% Follow Smart Desk"
    },
    {
      image: "https://customer-assets.emergentagent.com/job_fira-finance/artifacts/txibyeum_100%25%20FOLLOW%20SMART%20DESK.jpg",
      alt: "100% Follow Smart Desk"
    }
  ];

  // Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="bg-[#191919] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-5xl mx-auto">
        {/* Headline */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#F8F8F8] text-center mb-4 tracking-tight leading-tight">
          Lebih 800++ Student Fira Gunakan <span className="text-[#FF6699]">Fira Smart Desk</span> Setiap Hari
        </h2>

        {/* Subheadline */}
        <p className="text-lg md:text-xl lg:text-2xl text-[#F8F8F8]/70 text-center font-medium mb-10 max-w-3xl mx-auto">
          Apa kata mereka? semua ni legit dari pengguna Fira Smart Desk
        </p>

        {/* Statistics Banner */}
        <div className="mb-12 w-full lg:w-3/4 mx-auto">
          <img 
            src="https://customer-assets.emergentagent.com/job_fira-finance/artifacts/tdu5hcsj_BANNER%20STATISTIC.jpg"
            alt="Fira Smart Desk Statistics"
            className="w-full h-auto rounded-2xl md:rounded-3xl"
          />
        </div>

        {/* Image Slider */}
        <div className="relative w-full lg:w-1/2 lg:mx-auto">
          {/* Main Image Container */}
          <div className="relative overflow-hidden rounded-2xl md:rounded-3xl">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index}
                  className="w-full flex-shrink-0"
                >
                  <img 
                    src={testimonial.image}
                    alt={testimonial.alt}
                    className="w-full h-auto object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-[#191919]/80 hover:bg-[#FF6699] rounded-full flex items-center justify-center transition-all duration-300 group"
              aria-label="Previous slide"
            >
              <ChevronLeft className="w-5 h-5 md:w-6 md:h-6 text-[#F8F8F8]" />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-[#191919]/80 hover:bg-[#FF6699] rounded-full flex items-center justify-center transition-all duration-300 group"
              aria-label="Next slide"
            >
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6 text-[#F8F8F8]" />
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-3 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  currentSlide === index 
                    ? 'bg-[#FF6699] w-8' 
                    : 'bg-[#F8F8F8]/30 hover:bg-[#F8F8F8]/50'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
